import React, { useState } from 'react';

const RewardsPage = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle the visibility of terms and conditions
  const toggleTerms = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="dark:bg-gradient-to-r from-black to-stone-700 p-10 pt-24 min-h-screen flex flex-col items-center justify-center dark:text-white">
      {/* Header Section */}
      <div className="text-center mb-8">
        <h1 className="text-4xl font-semibold mb-4">Exclusive Discount Offer</h1>
        <p className="lg:px-10">
          Get up to 20% off on all items in our partnership marketplace, including T3i Sports clothing & apparel.
        </p>
      </div>

      {/* Rewards Marketplace Section */}
      <div className="bg-white text-black text-sm rounded-lg p-8 shadow-lg w-full max-w-lg">
        <div className="mb-6">
          <h2 className="text-lg font-bold mb-2">The Rewards Marketplace</h2>
          <p className="text-sm mb-4">Claim your discount with the following credit redemption values:</p>
          <ul className="list-disc text-sm pl-6 space-y-2">
            <li>500 credits = 5% off</li>
            <li>1000 credits = 10% off</li>
            <li>2000 credits = 20% off</li>
          </ul>
        </div>

        {/* Terms and Conditions Toggle Section */}
        <div>
          <button 
            className="text-blue-600 font-semibold" 
            onClick={toggleTerms}
          >
            Terms and Conditions
          </button>

          {isOpen && (
            <div className="mt-4 p-4 bg-gray-100 rounded-lg shadow-lg">
              <p className="mb-2 font-semibold">
                Here are the terms and conditions:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>The discount applies to individual items only and cannot be combined with other promotions, offers, or discounts.</li>
                <li>The maximum discount is 20% per item.</li>
                <li>The offer is valid on items in the partnership marketplace and T3i Sports clothing & apparel only.</li>
                <li>The discount cannot be applied to bundles, sets, or any pre-discounted items.</li>
                <li>This promotion is subject to availability and may be withdrawn or modified at any time without prior notice.</li>
                <li>All sales are final, and the discount cannot be retroactively applied to previous purchases.</li>
                <li>Other restrictions may apply.</li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Redeem Button Section */}
      <div className="mt-8">
        <a 
          href="/shop"
          onClick={() => alert("Please redeem your credits in the marketplace")}
          className="bg-gradient-to-r from-black to-red-500 hover:bg-yellow-500 text-white font-bold py-4 px-10 rounded-full"
        >
          Redeem Now
        </a>
      </div>
    </div>
  );
};

export default RewardsPage;
